import { render, staticRenderFns } from "./WorkBookInfoPerformanceIndicators.vue?vue&type=template&id=32974dc2&scoped=true&"
import script from "./WorkBookInfoPerformanceIndicators.vue?vue&type=script&lang=js&"
export * from "./WorkBookInfoPerformanceIndicators.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookInfoPerformanceIndicators.vue?vue&type=style&index=0&id=32974dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32974dc2",
  null
  
)

export default component.exports